import React from 'react';
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

import {setFeaturePicker} from "../../../../../../actions/sqftMenuFunctions";

const ConfirmButtons = (props) => {
  const {setFeaturePicker, confirmCallback} = props;

  const cancelCallback = () => {
    setFeaturePicker({ isOpen: false, partIds: [], shapeId: '', type: '' });
  }

  return (
    <div className="flex">
      <button className="ui-button10 ui-button10--blue"
              onClick={() => cancelCallback()}>
        <span className="ui-button10--uppercase">
          <FormattedMessage id={"Cancel"} />
        </span>
      </button>
      <button className="ui-button10 ui-button10--green"
              onClick={() => confirmCallback()}>
        <span className="ui-button10--uppercase">
          <FormattedMessage id={"Accept"} />
        </span>
      </button>
    </div>
  );
};

const mapStateToProps = (store) => ({
  sqftActiveShapeId: store.sqftMenuState.sqftActiveShapeId,
});

const mapDispatchToProps = {
  setFeaturePicker
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmButtons);

